import React from 'react';
import { ButtonsPanel } from '@cp/ds/src/components/buttonsPanel';
import { Container } from '@cp/ds/src/components/container';
import { CatalogItemActions } from 'src/widgets/catalog';
import { BottomBarProps } from './model';

export const BottomBar: React.FC<BottomBarProps> = ({ catalogItem }) => {
  return (
    <ButtonsPanel position="bottom-fixed">
      <Container>
        <CatalogItemActions catalogItem={catalogItem} />
      </Container>
    </ButtonsPanel>
  );
};
